import { connect } from 'react-redux';
import * as appCreators from '../../../../actions/inboxv2';
import { operations as creators } from '../../../../store/conversations';
import InboxCreateConversation from '../Legacy/InboxCreateConversation';

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const mapStateToProps = (state) => ({
  isUpdatingConversation: state.inboxv2.creatingConversation,
  open: state.inboxv2.createGroupOpened,
});

const mapDispatchToProps = {
  changeConversation: appCreators.selectConversation,
  createConversation: creators.createConversation,
  onClose: creators.closeCreateGroup,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  handleCreateConversation: async (conversationId) => {
    await delay(0);
    return dispatchProps.changeConversation(conversationId);
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(InboxCreateConversation);
